var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoCourseImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 386,
  height: 252,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E1DDDB",
  d: "M380 0H6a6 6 0 0 0-6 6v240a6 6 0 0 0 6 6h374a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M211 144v-36h-36v36zm-25-15 5 6.02 7-9.02 9 12h-28z"
})));
export { SvgNoCourseImage as ReactComponent };
export default __webpack_public_path__ + "8145b2ed4fb9b1786cad5c14541176e5.svg";